var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showInSupport)?_c('h3',{staticClass:"in-support-of mb-4"},[_vm._v(_vm._s(_vm.$t(_vm.inSupportLabel))+" "+_vm._s(_vm.inSupportName))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }